module.exports = __webpack_public_path__ + "img/compensation.a1261677.jpg";